import { extent, scaleLinear, scaleTime } from 'd3';

/* Defines scaling */
export function makeXScale( localChartData, localWidth ) {

    return scaleTime()
        .domain(
            extent( localChartData, function ( d ) {

                return d.column.date;

            } ),
        )
        .range( [ 0, localWidth ] );

}

export function makeYScale( localYDomain, localHeight ) {

    return scaleLinear()
        .domain( [ localYDomain.minValue, localYDomain.maxValue ] )
        .range( [ localHeight, 0 ] )
        .nice();

}
